'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.hasNegativeOffset = exports.hasPositiveOffset = exports.modifierIsAtModifier = exports.modifierIsGtModifier = exports.modifierIsLtModifier = exports.isValidModifiedMq = exports.hasUnnestedWhitespace = exports.hasNoScopes = exports.hasScopes = exports.isUnitRemOrEm = exports.isGroups = exports.isMediaQueryString = exports.isBreakpointProvider = exports.isTokenWithName = exports.isCalcFunction = exports.isTransformTranslateFunction = exports.isCSSFunction = exports.isToken = exports.isGradient = exports.isRadialGradient = exports.isLinearGradient = exports.isUrl = exports.isNotStringOrArray = exports.isRhythmUnit = exports.isLength = exports.isValidPositiveNumber = exports.isValidNonZeroNumber = exports.isPercentString = exports.isNotZeroString = exports.isNumberString = exports.isEmString = exports.isNumberWithUnit = exports.isNotZero = exports.isValidMqValue = exports.isDefaultBreakpoint = exports.isSingletonArray = exports.isLengthEqualTo = exports.isLengthGt = exports.isContained = undefined;

var _ramda = require('ramda');

var _ramdaAdjunct = require('ramda-adjunct');

var _breakpoints = require('../const/breakpoints');

var _config = require('../const/config');

var _regexp = require('../const/regexp');

var _units = require('../const/units');

var _formatting = require('./formatting');

var SCOPES = _config.CONFIG_FIELD_NAMES.SCOPES;

// -----------------------------------------------------------------------------
// List
// -----------------------------------------------------------------------------

var isContained = exports.isContained = (0, _ramda.flip)(_ramda.contains);

var isLengthGt = exports.isLengthGt = (0, _ramda.curry)(function (l, v) {
  return (0, _ramda.compose)((0, _ramda.gt)(_ramda.__, l), _ramda.length)(v);
});

var isLengthEqualTo = exports.isLengthEqualTo = (0, _ramda.curry)(function (l, v) {
  return (0, _ramda.compose)((0, _ramda.equals)(l), _ramda.length)(v);
});

// -----------------------------------------------------------------------------
// Misc
// -----------------------------------------------------------------------------

var isSingletonArray = exports.isSingletonArray = (0, _ramda.both)(_ramdaAdjunct.isArray, isLengthEqualTo(1));

var isDefaultBreakpoint = exports.isDefaultBreakpoint = (0, _ramda.equals)(_breakpoints.DEFAULT_BREAKPOINT_NAME);

var isValidMqValue = exports.isValidMqValue = (0, _ramda.anyPass)([isSingletonArray, _ramdaAdjunct.isString, _ramdaAdjunct.isValidNumber]);

// -----------------------------------------------------------------------------
// Numeric
// -----------------------------------------------------------------------------

var isNotZero = exports.isNotZero = (0, _ramda.complement)((0, _ramda.equals)(0));

// -----------------------------------------------------------------------------
// Types
// -----------------------------------------------------------------------------

var isNumberWithUnit = exports.isNumberWithUnit = (0, _ramda.curry)(function (units, value) {
  var possibleUnits = (0, _ramda.compose)(_formatting.joinWithPipe, _ramdaAdjunct.ensureArray)(units);
  var regExp = new RegExp('^-?\\d+(?:.\\d+)?(?:' + possibleUnits + ')$');
  return (0, _ramda.test)(regExp, value);
});

var isEmString = exports.isEmString = isNumberWithUnit([_units.LENGTH_UNITS.EM]);

/* eslint-disable-next-line no-restricted-globals */
var isNumberString = exports.isNumberString = (0, _ramda.both)(_ramdaAdjunct.isString, (0, _ramda.complement)(isNaN));

var isNotZeroString = exports.isNotZeroString = (0, _ramda.complement)(_ramda.equals)('0');

var isPercentString = exports.isPercentString = (0, _ramda.pipe)((0, _ramda.unless)(_ramdaAdjunct.isString, String), (0, _ramda.test)(_regexp.RE_PERCENT_NUMBER));

var isValidNonZeroNumber = exports.isValidNonZeroNumber = (0, _ramda.pipe)((0, _ramda.unless)(_ramdaAdjunct.isString, String), (0, _ramda.both)(isNumberString, isNotZeroString));

var isValidPositiveNumber = exports.isValidPositiveNumber = (0, _ramda.both)(_ramdaAdjunct.isValidNumber, _ramdaAdjunct.isPositive);

var isLength = exports.isLength = isNumberWithUnit((0, _ramda.values)(_units.LENGTH_UNITS));

var isRhythmUnit = exports.isRhythmUnit = (0, _ramda.test)(_regexp.RE_RHYTHM_UNITS);

var isNotStringOrArray = exports.isNotStringOrArray = (0, _ramda.both)(_ramdaAdjunct.isNotString, _ramdaAdjunct.isNotArray);

var isUrl = exports.isUrl = (0, _ramda.test)(_regexp.RE_URL);

var isLinearGradient = exports.isLinearGradient = (0, _ramda.test)(_regexp.RE_LINEAR_GRADIENT);

var isRadialGradient = exports.isRadialGradient = (0, _ramda.test)(_regexp.RE_RADIAL_GRADIENT);

var isGradient = exports.isGradient = (0, _ramda.either)(isLinearGradient, isRadialGradient);

var isToken = exports.isToken = (0, _ramda.test)(_regexp.RE_TOKEN);

var isCSSFunction = exports.isCSSFunction = (0, _ramda.test)(_regexp.RE_CSS_FUNCTION);
var isTransformTranslateFunction = exports.isTransformTranslateFunction = (0, _ramda.test)(_regexp.RE_TRANSFORM_TRANSLATE_FUNCTION);

var isCalcFunction = exports.isCalcFunction = (0, _ramda.test)(_regexp.RE_CALC_FUNCTION);

var isTokenWithName = exports.isTokenWithName = function isTokenWithName(names) {
  return function (value) {
    var possibleNames = (0, _ramda.compose)(_formatting.joinWithPipe, _ramdaAdjunct.ensureArray)(names);
    var regExp = new RegExp('^(' + possibleNames + '):(.*)$');
    return (0, _ramda.test)(regExp, value);
  };
};

var isBreakpointProvider = exports.isBreakpointProvider = (0, _ramda.both)((0, _ramda.has)('byName'), (0, _ramda.has)('byIndex'));

var isMediaQueryString = exports.isMediaQueryString = (0, _ramda.test)(_regexp.RE_MEDIA_QUERY_STRING);

var isGroups = exports.isGroups = (0, _ramda.test)(_regexp.RE_UNNESTED_COMMA);

var isUnitRemOrEm = exports.isUnitRemOrEm = isContained([_units.LENGTH_UNITS.EM, _units.LENGTH_UNITS.REM]);

var hasScopes = exports.hasScopes = (0, _ramda.has)(SCOPES);

var hasNoScopes = exports.hasNoScopes = (0, _ramda.complement)(hasScopes);

var hasUnnestedWhitespace = exports.hasUnnestedWhitespace = (0, _ramda.test)(_regexp.RE_UNNESTED_WHITESPACE);

var isValidModifiedMq = exports.isValidModifiedMq = (0, _ramda.test)(_regexp.RE_MODIFIED_MQ);

var modifierIsLtModifier = exports.modifierIsLtModifier = (0, _ramda.pipe)((0, _ramda.prop)('modifier'), (0, _ramda.equals)(_breakpoints.LT_MODIFIER));

var modifierIsGtModifier = exports.modifierIsGtModifier = (0, _ramda.pipe)((0, _ramda.prop)('modifier'), (0, _ramda.equals)(_breakpoints.GT_MODIFIER));

var modifierIsAtModifier = exports.modifierIsAtModifier = (0, _ramda.pipe)((0, _ramda.prop)('modifier'), (0, _ramda.equals)(_breakpoints.AT_MODIFIER));

var hasPositiveOffset = exports.hasPositiveOffset = (0, _ramda.contains)(_breakpoints.POSITIVE_OFFSET);

var hasNegativeOffset = exports.hasNegativeOffset = (0, _ramda.contains)(_breakpoints.NEGATIVE_OFFSET);


//////////////////
// WEBPACK FOOTER
// ./~/cssapi/lib/utils/predicate.js
// module id = 15
// module chunks = 168707334958949